import { useEffect } from 'react'
import { subscribeLeadership } from '@/lib/db/rxdb'

/**
 * Subscribes to RxDB leader-election transitions and reports whether this tab
 * currently holds leadership via the provided setter.
 *
 * Followers receive `false` until they take over leadership (e.g. because the
 * current leader tab closed), at which point this fires with `true`.
 */
export const useLeaderElection = (setIsLeader: (leader: boolean) => void): void => {
  useEffect(() => {
    const unsubscribe = subscribeLeadership((leader) => {
      setIsLeader(leader)
    })
    return unsubscribe
  }, [setIsLeader])
}
